import { Paper, Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export const ComplianceCheckList = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'complianceCheck' });

  return (
    <Stack
      spacing={1}
      sx={{
        maxWidth: {
          md: '100%',
          lg: '800px',
        },
      }}
    >
      <Paper sx={{ padding: 2 }}>
        <Typography variant="subtitle1">{t('title')}</Typography>
      </Paper>
      <Stack component="ul" spacing={1} padding={2}>
        {children}
      </Stack>
    </Stack>
  );
};
